export enum Sizes {
  XXS = 'xxs',
  XS = 'xs',
  DEFAULT = 'default',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  XXL = '2xl',
  ICON = 'icon',
  FILTER = 'filter',
}
